// extracted by mini-css-extract-plugin
export default {"scrollButton":"ScrollToTop_scrollButton__QZmKc"};